export class DuplicatesDTOResponse {
  id: number;
  number: string;
  value: string;
  expiration: string;
  isPaid: boolean;
  paid: boolean;
}
